export interface UserInfoResponse {
  email: string
  name: AccountName
  organization: string
  authorization: Authorization
}

export interface Privilege {
  companyId: string
  role: string
}

export interface AccountName {
  first: string
  last: string
}

export interface Authorization {
  msisdn?: string
  privilege?: Array<Privilege>
  bss: string
  rel_contact_id: string
}

export const isUserInfoResponse = (user: any): user is UserInfoResponse => {
  if (user === undefined) {
    return false
  }
  return (
    user &&
    typeof user.email === 'string' &&
    typeof user.name === 'object' &&
    typeof user.name.first === 'string' &&
    typeof user.name.last === 'string' &&
    typeof user.organization === 'string' &&
    typeof user.authorization === 'object' &&
    typeof user.authorization.bss === 'string' &&
    typeof user.authorization.rel_contact_id === 'string'
  )
}

export function isMindFleetManager(userInfo: UserInfoResponse): boolean {
  const isMindBss = userInfo.authorization.bss === 'mind'
  const fleet_manager = userInfo.authorization.privilege?.find((priv) => priv.role == 'fleet_manager')
  return isMindBss && !!fleet_manager
}

export function isSnappyUser(userInfo: UserInfoResponse): boolean {
  return userInfo.authorization.bss === 'snappy'
}
